// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"2b92b704","247":"7f9d64db","513":"5aa9774b","665":"4313a913","706":"cc727622"}[chunkId] + ".chunk.js";
};